import type { Component } from 'solid-js'
import { Circle } from 'styled-system/jsx'
import { AppTooltip } from './AppTooltip'

export const Rank: Component<{ rank?: string, dimensions?: string }> = (props) => {
	return (
    <AppTooltip content={props.rank?.replace('_', ' ')}>
      <Circle
        backgroundSize='cover'
        style={{
          width: props?.dimensions || '16px',
          height: props?.dimensions || '16px',
          'background-image': `url(/rank/${props.rank}.png)`,
        }}
        />
    </AppTooltip>
	)
}
